import PassportAdminHealthcareReviewItem from "./PassportAdminHealthcareReviewItem";
export default PassportAdminHealthcareReviewItem;